import Utils from '../../utils/Utils';

let instanceActive = null;
class ActivesSingleton {
  constructor() {
    if (!instanceActive) instanceActive = this;
    return instanceActive;
  }

  getActives() {
    return this.actives;
  }

  setActives(actives) {
    this.actives = actives;
  }

  getTree() {
    if (this.actives && this.actives.length !== 0) {
      const tree = this.actives
        .map(i => i.text)
        .reduce((current, previous) => previous.concat('/').concat(current));
      return tree;
    }
  }

  setNav(nav) {
    this.navcodes = nav;
  }

  getNav() {
    return this.navcodes;
  }

  getTvNode() {
    return Utils.getApaMetadataKey('links_nav_configuration', '{}', 'clarotv');
  }

  nodeTvExits() {
    if (this.navcodes.find(it => (it === this.getTvNode() || it.includes(this.getTvNode()) ))) return true;
    return false;
  }
}
export default ActivesSingleton;



// WEBPACK FOOTER //
// ./src/components/Header/ActivesSingleton.js